import React from "react";
import { Card, CardContent, TextField, InputAdornment, Stack, Box, Typography } from "@mui/material";
import { Search as SearchIcon, KeyboardArrowRight as ArrowRightIcon } from "@mui/icons-material";
import { useWidgetMsg } from "../../hooks/widget/useWidgetMsg";

export default function SearchAndFaqs({ searchQuery, onSearchChange, filteredFaqs, onFaqClick, widget}) {
	const { msg } = useWidgetMsg();

	return (
		<Card
			sx={{
				background: "white",
				borderRadius: "16px",
				flexShrink: 0,
				boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.15)",
			}}
		>
			<CardContent sx={{ padding: "20px !important" }}>
				<TextField
					fullWidth
					placeholder={msg("home.search", "Search")}
					value={searchQuery}
					onChange={onSearchChange}
					size="small"
					sx={{
						mb: 2,
						"& .MuiOutlinedInput-root": {
							borderRadius: "18px",
							border: "1px solid #DBDEEB",
							"& fieldset": { border: "none" },
						},
					}}
					InputProps={{
						endAdornment: (
							<InputAdornment position="end">
								<SearchIcon sx={{ fontSize: 16 }} />
							</InputAdornment>
						),
					}}
				/>
				{filteredFaqs.length > 0 && (
					<Stack spacing={1.5}>
						{filteredFaqs.map((faq, index) => (
							<Box
								key={index}
								sx={{
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
									cursor: "pointer",
									"&:hover": { opacity: 0.7 },
								}}
								onClick={(e) => onFaqClick(faq, e)}
							>
								<Typography variant="body2" sx={{ fontSize: "12px", flex: 1 }}>
									{faq.doc?.title || "N/A"}
								</Typography>
								<ArrowRightIcon sx={{ fontSize: 16 }} />
							</Box>
						))}
					</Stack>
				)}
				{filteredFaqs.length === 0 && (
					<Typography variant="body2" sx={{ fontSize: "12px", color: "text.secondary", flex: 1, textAlign: "center" }}>
						{msg("help.no_faq_found", "No Faqs Found")}
					</Typography>
				)}
			</CardContent>
		</Card>
	);
}

